export type Surface = 'driver' | 'mechanic' | 'legacy' | 'dev'
export type CanonicalSurface = 'driver' | 'mechanic'

const ORIGINS: Record<CanonicalSurface, string> = {
  driver: 'https://drivers.claimshieldpro.com',
  mechanic: 'https://mechanics.claimshieldpro.com',
}

export function surfaceForHost(hostname: string): Surface {
  if (hostname === 'drivers.claimshieldpro.com') return 'driver'
  if (hostname === 'mechanics.claimshieldpro.com') return 'mechanic'
  if (hostname === 'rewards.claimshieldpro.com') return 'legacy'
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname?.endsWith('.pages.dev')) return 'dev'
  return 'dev'
}

export function hostSurface(): Surface {
  return surfaceForHost(window.location.hostname)
}

export function originForSurface(surface: CanonicalSurface): string {
  return ORIGINS[surface]
}

export function currentSurface(): Surface {
  const host = hostSurface()
  if (host !== 'dev' || !import.meta.env.DEV) return host
  const requested = new URLSearchParams(window.location.search).get('surface')
  if (requested === 'driver' || requested === 'mechanic') {
    try { sessionStorage.setItem('cs_dev_surface', requested) } catch { /* Storage can be disabled. */ }
    return requested
  }
  try {
    const saved = sessionStorage.getItem('cs_dev_surface')
    if (saved === 'driver' || saved === 'mechanic') return saved
  } catch { /* Use the driver default. */ }
  const configured = import.meta.env.VITE_DEV_SURFACE
  return configured === 'mechanic' ? 'mechanic' : 'driver'
}

export function navigateToSurface(surface: CanonicalSurface, path: string): void {
  const pathname = path.startsWith('/') && !path.startsWith('//') ? (path.split(/[?#]/)[0] ?? '/') : '/'
  window.location.assign(`${originForSurface(surface)}${pathname}`)
}
